// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEnvelope, faHorse, faCalendarAlt, faHatCowboy, faHandshake, faFolder, faList, faFilePdf, faMoneyBill, faClipboardList, faMoneyBillWave, faCubes, faWallet } from '@fortawesome/free-solid-svg-icons';
import App from './app.vue';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
import Vue2Filters from 'vue2-filters';
import router from './router';
import * as config from './shared/config/config';
import * as bootstrapVueConfig from './shared/config/config-bootstrap-vue';
import JhiItemCountComponent from './shared/jhi-item-count.vue';
import JhiSortIndicatorComponent from './shared/sort/jhi-sort-indicator.vue';
import InfiniteLoading from 'vue-infinite-loading';
import AuditsService from './admin/audits/audits.service';
import ValidationService from '@/shared/validation/validation.service';
import 'vue-select/dist/vue-select.css';

import HealthService from './admin/health/health.service';
import MetricsService from './admin/metrics/metrics.service';
import LogsService from './admin/logs/logs.service';
import UserManagementService from '@/admin/user-management/user-management.service';

import LoginService from './account/login.service';
import AccountService from './account/account.service';

import '../content/scss/vendor.scss';
import AlertService from '@/shared/alert/alert.service';
import TranslationService from '@/locale/translation.service';
import ConfigurationService from '@/admin/configuration/configuration.service';

/* tslint:disable */

import AddressService from '@/entities/address/address.service';
import FirmaInfoService from '@/account/firmsettings/firmsettings.service';
import StallService from '@/entities/stall/stall.service';
import PferdService from '@/entities/pferd/pferd.service';
import TerminService from '@/entities/termin/termin.service';
import KundeService from '@/entities/kunde/kunde.service';
import BuchhaltungService from '@/buchhaltung/buchhaltung.service';
import ZusatzleistungService from '@/entities/zusatzleistung/zusatzleistung.service';
import LeistungService from '@/entities/leistung/leistung.service';
import GrundleistungService from '@/entities/grundleistung/grundleistung.service';
import BezahlmglService from '@/entities/bezahlmgl/bezahlmgl.service';
import BildService from '@/entities/bild/bild.service';
import AusgabeService from '@/entities/ausgabe/ausgabe.service';
import MaterialService from '@/entities/material/material.service';
import NotificationService from '@/entities/notification/notification.service';
// jhipster-needle-add-entity-service-to-main-import - JHipster will import entities services here

/* tslint:enable */
Vue.config.productionTip = false;
config.initVueApp(Vue);
config.initFortAwesome(Vue);
bootstrapVueConfig.initBootstrapVue(Vue);
Vue.use(Vue2Filters);
library.add(faEnvelope, faHorse, faCalendarAlt, faHatCowboy, faHandshake, faFolder, faList, faFilePdf, faMoneyBill, faClipboardList, faMoneyBillWave, faCubes, faWallet);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('jhi-item-count', JhiItemCountComponent);
Vue.component('jhi-sort-indicator', JhiSortIndicatorComponent);
Vue.component('infinite-loading', InfiniteLoading);

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

const i18n = config.initI18N(Vue);
const store = config.initVueXStore(Vue);

const alertService = new AlertService(store);
const translationService = new TranslationService(store, i18n);
const loginService = new LoginService();
const accountService = new AccountService(store, translationService, router);

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next('/not-found');
  }

  if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
    accountService.hasAnyAuthorityAndCheckAuth(to.meta.authorities).then(value => {
      if (!value) {
        sessionStorage.setItem('requested-url', to.fullPath);
        next('/forbidden');
      } else {
        next();
      }
    });
  } else {
    // no authorities, so just proceed
    next();
  }
});

/* tslint:disable */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  provide: {
    loginService: () => loginService,
    userService: () => new UserManagementService(),
    grundleistungService: () => new GrundleistungService(),
    bildService: () => new BildService(),

    auditsService: () => new AuditsService(),
    validationService: () => new ValidationService(),

    healthService: () => new HealthService(),

    configurationService: () => new ConfigurationService(),
    logsService: () => new LogsService(),
    metricsService: () => new MetricsService(),
    alertService: () => alertService,
    translationService: () => translationService,
    addressService: () => new AddressService(),
    stallService: () => new StallService(),
    pferdService: () => new PferdService(),
    terminService: () => new TerminService(),
    kundeService: () => new KundeService(),
    firmaInfoService: () => new FirmaInfoService(),
    zusatzleistungService: () => new ZusatzleistungService(),
    leistungService: () => new LeistungService(),
    bezahlmglService: () => new BezahlmglService(),
    buchhaltungService: () => new BuchhaltungService(),
    ausgabeService: () => new AusgabeService(),
    materialService: () => new MaterialService(),
    notificationService: () => new NotificationService(),
    // jhipster-needle-add-entity-service-to-main - JHipster will import entities services here
    accountService: () => accountService,
  },
  i18n,
  store,
});
